import React from 'react';
import PropTypes from 'prop-types';
import AnimatedFollowButton from './animated-follow-button';
import { followContributor, unfollowContributor } from '../../services/contributor-service';
import { recordProfileStatistic } from '../../services/statistics-service';
import useSynchronizedFollowStatus from './follow-button/profile-follow-state-listener';

export default function AnimatedProfileFollowButton({
  isProfileFollowedByCurrentUser, profileId, onUnfollow, isOnWireSide,
  followEventName, unfollowEventName,
}) {
  const btnRef = React.useRef();
  const broadcast = useSynchronizedFollowStatus({
    id: profileId,
    onStatusChanged: d => btnRef.current && btnRef.current.notify(d),
  });
  const props = {
    broadcast,
    onUnfollow,
    initialStatus: isProfileFollowedByCurrentUser,
    buttonName: isOnWireSide ? 'profile-follow-button-on-sidebar' : 'profile-follow-button',
    followAction: () => followContributor(profileId),
    unfollowAction: () => unfollowContributor(profileId),
    collectStats: d => recordProfileStatistic(profileId, d ? followEventName : unfollowEventName),
  };

  return <AnimatedFollowButton ref={btnRef} {...props} />;
}

AnimatedProfileFollowButton.propTypes = {
  isProfileFollowedByCurrentUser: PropTypes.bool.isRequired,
  profileId: PropTypes.number.isRequired,
  onUnfollow: PropTypes.func,
  isOnWireSide: PropTypes.bool,
  followEventName: PropTypes.string,
  unfollowEventName: PropTypes.string,
};

AnimatedProfileFollowButton.defaultProps = {
  onUnfollow: null,
  isOnWireSide: false,
  followEventName: 'follow_profile',
  unfollowEventName: 'unfollow_profile',
};
